import React from 'react';
import Router from './components/Router';
import './App.scss'

function App() {
  return (
    <Router />
  );
}
export default App;